import { Link } from 'react-router-dom';

import './AdultAccountPage.css';

const { resolveAccountsConfig, validateAccountsRuntimeOrigin } = require('../accountsEnvironment');
const accountsConfig = resolveAccountsConfig({
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_ACCOUNTS_V1_ENABLED: process.env.REACT_APP_ACCOUNTS_V1_ENABLED,
  REACT_APP_ACCOUNTS_API_URL: process.env.REACT_APP_ACCOUNTS_API_URL,
  REACT_APP_ACCOUNTS_FRONTEND_ORIGIN: process.env.REACT_APP_ACCOUNTS_FRONTEND_ORIGIN,
});
if (typeof window !== 'undefined') validateAccountsRuntimeOrigin(accountsConfig, window.location.origin);
export const accountsEnabled = accountsConfig.enabled;
const apiBaseUrl = accountsConfig.apiBaseUrl;

export const ADULT_AUTH_UNAVAILABLE = 'adult-auth-unavailable';

export class AdultAuthRequestError extends Error {
  constructor(status) {
    super('No fue posible completar la solicitud.');
    this.status = status;
  }
}

export async function request(path, options = {}) {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });

  if (!response.ok) {
    throw new AdultAuthRequestError(response.status);
  }

  return response.status === 204 ? null : response.json();
}

export function requiresEmailConfirmation(mode, adult) {
  return mode === 'register' && adult?.session_available !== true;
}

export function passwordMinLengthForMode(mode) {
  return mode === 'register' ? 8 : 1;
}

export async function requestWithAdultRefresh(path, options = {}, requestFn = request) {
  try {
    return await requestFn(path, options);
  } catch (error) {
    if (error?.status !== 401) throw error;
  }

  await requestFn('/auth/refresh', { method: 'POST' });
  return requestFn(path, options);
}

export async function restoreAdultSession(requestFn = request) {
  try {
    return await requestFn('/auth/me');
  } catch (error) {
    if (error?.status !== 401) return ADULT_AUTH_UNAVAILABLE;
  }

  try {
    return await requestFn('/auth/refresh', { method: 'POST' });
  } catch (error) {
    if (error?.status === 401) return null;
    return ADULT_AUTH_UNAVAILABLE;
  }
}

export default function AdultAuthPanel() {
  if (!accountsEnabled) return null;
  return <nav aria-label="Entradas de TechnoMathPR"><Link className="tmag-account-entry" to="/account">CUENTA TECHNOMATHPR →</Link><Link className="tmag-account-entry" to="/student">JUGAR EN MI CLASE →</Link></nav>;
}
